import React from 'react'
import Box from '@material-ui/core/Box'
import FormSubheader from '../form-subheader'
import Personal from '../../form-components/personal'
import Social from '../../form-components/social'
import Testimonials from '../../form-components/testimonials'
import Photos from '../../form-components/photos'
import { useCreateProfileFieldStyles } from '../field-styles'

const PersonalMediaSection = () => {
  const fieldClasses = useCreateProfileFieldStyles()

  return (
    <Box className={fieldClasses.sectionStack}>
      <Personal />
      <Box className={fieldClasses.fieldSection}>
        <FormSubheader
          title="Social links"
          description="Add links to the social profiles you want students to see."
        />
        <Social />
      </Box>
      <Testimonials />
      <Photos />
    </Box>
  )
}

export default PersonalMediaSection
